import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner, Table } from '@/components';
import { ValueItem } from '@/types/stockSummary';
import { getHeaderColumnsGroup, getTableColumns } from './getTableColumns';

import { tableFilters } from './tableFilters';

type StockSumaryTableProps = {
  data?: ValueItem[];
  isLoading?: boolean;
};

const StockSummaryTable: FC<StockSumaryTableProps> = ({ data, isLoading }) => {
  const tableColumns = getTableColumns();
  const { t } = useTranslation('stockSummary');

  const headerColumnsGroup = getHeaderColumnsGroup(t, data);

  return (
    <>
      {isLoading && (
        <div
          style={{ zIndex: 10, background: 'rgba(0,0,0, 0.2)' }}
          className="absolute top-0 bottom-0 left-0 right-0 z-10 flex align-items-center justify-content-center"
        >
          <LoadingSpinner />
        </div>
      )}

      <div className="">
        <Table
          columns={tableColumns}
          data={data}
          isLoading={isLoading}
          filters={tableFilters}
          filterDisplay="menu"
          headerColumnGroup={headerColumnsGroup}
          paginator
        />
      </div>
    </>
  );
};

export default StockSummaryTable;
